export function getTeamMatchDisplay(row) {
  if (row?.team_a_or_b === "teamA") {
    return {
      isTargetTeamA: true,
      teamA: {
        name: row.team_CalculatedName_target || row.teamAName,
        code: row.team_CalculatedCode_target || "",
      },
      teamB: {
        name: row.team_CalculatedName_opponent || row.teamBName,
        code: row.team_CalculatedCode_opponent || "",
      },
    };
  }

  if (row?.team_a_or_b === "teamB") {
    return {
      isTargetTeamA: false,
      teamA: {
        name: row.team_CalculatedName_opponent || row.teamAName,
        code: row.team_CalculatedCode_opponent || "",
      },
      teamB: {
        name: row.team_CalculatedName_target || row.teamBName,
        code: row.team_CalculatedCode_target || "",
      },
    };
  }

  return {
    isTargetTeamA: null,
    teamA: { name: row?.teamAName || "", code: "" },
    teamB: { name: row?.teamBName || "", code: "" },
  };
}
